import OperationsOwnerPerformanceReportPage from "../../shared/OperationsOwnerPerformanceReportPage";

const ManagementOperationsOwnerPerformanceReportPage = () => (
  <OperationsOwnerPerformanceReportPage operationsSource="Management" />
);

export default ManagementOperationsOwnerPerformanceReportPage;
